import { hash } from './hash';

export const generateCodeChallenge = async (): Promise<{
  codeChallenge: string;
  codeVerifier: string;
}> => {
  const codeVerifier = [...crypto.getRandomValues(new Uint8Array(40))]
    .map((m) => ('0' + m.toString(16)).slice(-2))
    .join('');

  const verifierHashCode = await hash('SHA-256', codeVerifier);
  const codeChallenge = btoa(
    String.fromCharCode(...new Uint8Array(verifierHashCode))
  )
    .replace(/=/g, '')
    .replace(/\+/g, '-')
    .replace(/\//g, '_');

  return { codeVerifier, codeChallenge };
};
